import { useState, useEffect } from "react";
import Colors from "assets/Colors";
import Input from "components/common/Input";
import ColorSelector from "components/common/ColorSelector";
import CloseIconSmall from "components/icons/CloseIconSmall";
import DropIcon from "components/icons/DropIcon";
import { useFormik } from "formik";
import useSubcategoryMutations from "graphql/useSubcategoryMutations";
import Selector from "components/common/Selector";

import { useTranslation } from "react-i18next";
import s from "./styles";
import { BSON } from "realm-web";

function AddSubCategoryModal({
  parentCategory,
  close,
  setNewSubCategory,
  setNewSubcategories,
  newSubcategories,
  editItem,
  categories,
  onAddSuccessSubCategory,
}) {
  const { t } = useTranslation();
  const { addSubcategory, updateSubcategory } = useSubcategoryMutations();
  const [saving, setSaving] = useState(false);

  const { handleSubmit, handleChange, values, resetForm } = useFormik({
    initialValues: {
      name: "",
      color: null,
    },

    onSubmit: (values) => {
      setSaving(true);
      const subCategoryValues = {
        ...values,
        categoryId: values.categoryId || parentCategory.id,
        updateDatetime: new Date(),
        creationDatetime: new Date(),
        assignedItems: undefined,
      };
      const newSubCategoryValues = {
        _id: new BSON.ObjectId(),
        ...values,
        categoryId: values.categoryId || parentCategory.id,
        updateDatetime: new Date(),
        creationDatetime: new Date(),
        assignedItems: undefined,
      };

      if (parentCategory?.id || values.categoryId) {
        if (values.categoryId || parentCategory.id) {
          if (editItem && Object.keys(editItem).length > 0) {
            updateSubcategory(editItem, {
              ...subCategoryValues,
              __typename: undefined,
            })
              .then((data) => {
                setSaving(false);
                setNewSubCategory(data._id, data);
                resetForm();
                close();
              })
              .catch(() => {
                setSaving(false);
              });
          } else {
            addSubcategory(subCategoryValues)
              .then((data) => {
                setSaving(false);
                setNewSubCategory(data._id, data);
                resetForm();
                close();
                onAddSuccessSubCategory();
              })
              .catch(() => {
                setSaving(false);
              });
          }
        } else {
          setNewSubCategory(null, subCategoryValues);
          setSaving(false);
          resetForm();
          close();
        }
      } else {
        if (editItem && editItem._id) {
          setNewSubCategory(
            newSubcategories.map((subs) => {
              if (subs._id.toString() == editItem._id.toString()) {
                subs.name = values.name;
                subs.color = values.colot;
              } else {
                subs;
              }
            })
          );

          resetForm();

          setSaving(false);

          close();
        } else {
          setNewSubcategories((prevSubs) => [
            ...prevSubs,
            newSubCategoryValues,
          ]);
          setSaving(false);
          resetForm();
          close();
        }
      }
    },
  });

  useEffect(() => {
    if (editItem) {
      Object.entries(editItem).forEach((obj) => {
        handleChange({
          target: {
            name: obj[0],
            value: obj[1],
          },
        });
      });
    } else {
      resetForm();
    }
    return function () {
      resetForm();
    };
  }, [editItem]);

  return (
    <div>
      <s.HeaderContainer>
        <s.CloseButtonWrapper
          onClick={() => {
            resetForm();
            close();
          }}
        >
          <CloseIconSmall />
        </s.CloseButtonWrapper>
        <div>{t("SubCategory.newSubcategory")}</div>

        <s.SaveTextWrapper
          enable={
            (categories && values.categoryId && values.name && !saving) ||
            (!categories && values.name && !saving)
          }
          onClick={() =>
            ((categories && values.categoryId && values.name && !saving) ||
              (!categories && values.name && !saving)) &&
            handleSubmit()
          }
        >
          {t("actions.save")}
        </s.SaveTextWrapper>
      </s.HeaderContainer>
      <s.BodyWrapper>
        <s.LeftContainer>
          <s.Title>{t("SubCategory.subCategory")}</s.Title>
          <s.Line />
          <s.SubTitle>{t("SubCategory.fields.subcategory.label")}</s.SubTitle>
          <Input
            style={{
              marginBottom: "53px",
            }}
            placeholder={t("SubCategory.fields.subcategory.placeholder")}
            name="name"
            onChange={handleChange}
            value={values.name}
          />
          <s.Title>{t("SubCategory.fields.category.label")}</s.Title>
          <s.Line style={{ marginBottom: "23px" }} />
          {categories ? (
            <Selector
              options={categories.map((c) => ({ value: c._id, name: c.name }))}
              style={{ width: "100%", marginBottom: "20px" }}
              placeholder={t("SubCategory.fields.categoryId.placeholder")}
              onChange={(value) => {
                handleChange({
                  target: {
                    name: "categoryId",
                    value,
                  },
                });
              }}
              value={values.categoryId}
            />
          ) : (
            <Input
              style={{
                marginBottom: "20px",
              }}
              disabled
              name="name"
              value={parentCategory?.name}
              placeholder={t(
                "SubCategory.fields.categoryId.placeholderReadOnly"
              )}
            />
          )}
        </s.LeftContainer>
        <div>
          <s.Title>{t("SubCategory.fields.color.label")}</s.Title>
          <s.ColorWrapper color={values.color}>
            <DropIcon color={values.color ? undefined : Colors.GREY} />
          </s.ColorWrapper>
          <ColorSelector
            handleChange={(value) => {
              handleChange({
                target: {
                  name: "color",
                  value,
                },
              });
            }}
          />
        </div>
      </s.BodyWrapper>
    </div>
  );
}

export default AddSubCategoryModal;
